/**
 * Global axios auth interceptor.
 *
 * ~67 legacy pages import the default axios instance directly instead of
 * going through apiFetch, and many of them send no Authorization header.
 * Registering the interceptor on the default instance closes that gap for
 * every one of them at once: the JWT is attached exactly the way apiFetch
 * does it, but only for requests to our own backend — never third-party
 * hosts. Calls that already set Authorization (manual Bearer headers,
 * auditor-portal tokens) are left untouched.
 *
 * Imported for its side effect in src/index.js. New code should still use
 * apiFetch (services/api_service.js); this is a safety net for the legacy
 * generation until the V3 migration retires it.
 */
import axios from "axios";

const BACKEND_ORIGIN = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

function isBackendRequest(url) {
  if (!url) return false;
  if (url.startsWith("/")) return true; // relative → same origin
  if (BACKEND_ORIGIN && url.startsWith(BACKEND_ORIGIN)) return true;
  try {
    return new URL(url).origin === window.location.origin;
  } catch {
    return false;
  }
}

axios.interceptors.request.use((config) => {
  const hasAuth =
    config.headers && (config.headers.Authorization || config.headers.authorization);
  if (!hasAuth && isBackendRequest(config.url)) {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token") || "";
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});
